import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ title, dark = false, className = "" }) => (
  <Reveal className={className}>
    <h2 className={`font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight ${dark ? "text-white" : "text-brand-navy"}`}>
      {title}
    </h2>
  </Reveal>
);
